import { queryClient } from '@hotjar/webapp/utils/react-query';
import { SEGMENTS_QUERY_KEY } from '@hotjar/webapp/domains/segments/constant';
import { fetchSegments } from './fetchSegments';
import { getSegmentById } from './getSegmentById';

import type { Store } from '../../../store/list/types';

export const notifySegmentsUpdated = (store: Store): void => {
  const { site } = store.getState();

  if (!site) {
    return;
  }

  queryClient.invalidateQueries([SEGMENTS_QUERY_KEY, { siteId: site.id }]);
  fetchSegments(site).then((segmentArray) => {
    const { currentSegment, setSegments, setCurrentSegment } = store.getState();

    setSegments(segmentArray);
    if (currentSegment) {
      const newSegmentToSet = getSegmentById(currentSegment.id, segmentArray) ?? null;
      setCurrentSegment(newSegmentToSet);
    }
  });
};
